import { FC, ReactNode } from 'react';

type PopoutToggleIconVariant = 'open' | 'contract';

interface PopoutToggleIconProps {
  variant: PopoutToggleIconVariant;
}

const variantPaths: Record<PopoutToggleIconVariant, ReactNode> = {
  // Ionicons open-outline paths.
  open: (
    <>
      <path d="M384 224v184a40 40 0 0 1-40 40H104a40 40 0 0 1-40-40V168a40 40 0 0 1 40-40h167" />
      <path d="M336 64h112v112" />
      <path d="M224 288L440 72" />
    </>
  ),
  // Ionicons contract-outline paths.
  contract: (
    <>
      <path d="M304 416V304h112" />
      <path d="M314.2 314.2L432 432" />
      <path d="M208 96v112H96" />
      <path d="M197.8 197.8L80 80" />
    </>
  ),
};

// Inline SVG (ionicons outline paths). IonIcon is a custom element registered
// only in the main window — inside the popout document it never upgrades, so
// the icon must not depend on the custom elements registry.
const PopoutToggleIcon: FC<PopoutToggleIconProps> = ({ variant }) => (
  <svg
    viewBox="0 0 512 512"
    width="15"
    height="15"
    fill="none"
    stroke="currentColor"
    strokeWidth="40"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    {variantPaths[variant]}
  </svg>
);

export default PopoutToggleIcon;
